import Select from './select';
import { useDebouncedSearch } from '../../../util/misc';
import { GENERICA_SPRITE_URL } from '../../../config';

const mapToOptions = (list: string[]) => list.map((name) => ({ name, value: name }));

export default function GenericaLocationFilters({
    country,
    region,
    city,
    countries,
    regions,
    cities,
    setCountry,
    setRegion,
    setCity,
}: {
    country: string;
    region: string;
    city: string;
    countries: string[];
    regions: string[];
    cities: string[];
    setCountry: (v: string) => void;
    setRegion: (v: string) => void;
    setCity: (v: string) => void;
}) {
    const search = useDebouncedSearch();

    return (
        <div className="shops__accordion-filters">
            <Select
                name="Все страны"
                value={country}
                options={mapToOptions(countries)}
                onChange={(v) => setCountry(v || '')}
            />
            <Select
                name="Все регионы"
                value={region}
                options={mapToOptions(regions)}
                onChange={(v) => setRegion(v || '')}
            />
            <Select
                name="Все насел. пункты"
                value={city}
                options={mapToOptions(cities)}
                onChange={(v) => setCity(v || '')}
            />

            <div className="shops__accordion-item">
                <input
                    className="search__shops"
                    type="text"
                    name="search-shops"
                    id="search-shops"
                    placeholder="Поиск"
                    onChange={search}
                />
                <label className="visually-hidden" htmlFor="search-shops">
                    Поиск по магазинам
                </label>
                <svg className="main-header__search-icon" width="24" height="24">
                    <use xlinkHref={GENERICA_SPRITE_URL + '#icon-search'} />
                </svg>
            </div>
        </div>
    );
}
